module.exports = __webpack_public_path__ + "img/palmmain2.a8d5bd6c.png";